import { Service } from "./Service.js";
import { validateTidalLicense } from "../../../base/index.js";
validateTidalLicense();
export {
  Service
};
//# sourceMappingURL=index.js.map
